import React, { useMemo } from 'react'
import { useQuery } from 'react-query'
import { Container, Row, Col, Logo } from 'react-angle-dashboard-components'
import styled from 'styled-components'

import { groupService, planService } from '../../services'
import { useGbsContext } from '../../store'
import { GbsStep } from '../../store/interfaces'
import { useBottomBar } from '../../store/selectors'
import { useStep } from '../../hooks'
import { PlanWrapper, CostInformation } from '../../components/PlanInformation'
import { YourPlanDetails } from '../FinalQuoteDetails/YourPlanDetails'

const Title = styled.h1`
  color: #00406d;
`

const CompanyInformation = styled.div`
  background-color: #e9ecef;
  padding: 1rem 0.825rem;
  margin-right: 0.825rem;
  color: #00406d;
`

const PlanDetail = styled.div`
  > div {
    padding: 0;

    .collapse {
      display: table-row !important;
    }

    table tbody tr:odd {
      background-color: rgb(248, 249, 250) !important;
    }

    table tbody tr:even {
      background-color: rgb(255, 255, 255) !important;
    }
  }

  margin-bottom: 3rem;
`

const Carrier = styled(Col)`
  display: flex;
  flex-direction: column;

  h3 {
    margin-bottom: 0;
  }

  .btn-wrapper-benefits {
    display: none;
  }
`

export const Download = () => {
  const bottomBarData = useBottomBar()
  const { dispatch } = useGbsContext()
  const stepKey = 'download'

  const stepConfig: Omit<GbsStep, 'data'> = useMemo(() => {
    return {
      bottomBar: {
        hidden: true
      },
      topBar: {
        hidden: true
      }
    }
  }, [])

  useStep(stepKey, stepConfig, dispatch)
  // const { employees, isLoadingEmployees } = useEmployees(employeeService)
  const { data: company } = useQuery('company', () => groupService.getInfo())

  const { data: plans } = useQuery('selectedPlans', () =>
    planService.getSelectablePlans({ selected: 1 })
  )

  return (
    <Container>
      <Row className="mt-3">
        <Col>
          <Title>{company?.group_name} Plans</Title>
          <p>Estimated costs based on your employees information.</p>
        </Col>
        <Col style={{ textAlign: 'right' }}>
          <Logo
            color={'angle-primary' as any}
            variant="full"
            size="lg"
            width={150}
          />
          <p style={{ color: '#00406d' }}>
            {company?.admin_contact_info?.work_email}
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex flex-row">
          <CompanyInformation>
            Avg Age: {bottomBarData?.info?.avgAge}
          </CompanyInformation>
          <CompanyInformation>
            Emp #: {bottomBarData?.info?.numberOfEmployees}
          </CompanyInformation>
          <CompanyInformation>
            Zip: {bottomBarData?.info?.zip}
          </CompanyInformation>
          <CompanyInformation>
            Contribution: {bottomBarData?.info?.contribution?.value}
            {bottomBarData?.info?.contribution?.type === 'percentage'
              ? '%'
              : '$'}
          </CompanyInformation>
        </Col>
      </Row>
      <hr />
      <Row>
        <Carrier>
          <h3>Carrier: Angle Health ({plans?.length} plans selected)</h3>
          <div className="d-flex flex-wrap pt-3">
            {plans?.map((plan) => (
              <PlanWrapper
                key={plan.id}
                style={{ height: 410, marginRight: 30 }}
              >
                <CostInformation plan={plan} compressedVersion />
              </PlanWrapper>
            ))}
          </div>
        </Carrier>
      </Row>
      <hr />
      <Row>
        <Col>
          <h2>Your Plan Details</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <PlanDetail>
            <YourPlanDetails expanded={true} header={false} />
          </PlanDetail>
        </Col>
      </Row>
    </Container>
  )
}

export default Download
